import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import { Mitarbeiter } from '@chancenwerk/master-data-management/users/entities/Mitarbeiter.js';

const resolveGetSubstituteLeKosKPF = (kpfID: string) => async (gqlFields: BaseQLSelectionSet<Mitarbeiter>) => {
  const kpf = await getByID(
    KPF,
    kpfID,
  )({ substituteKPFIDs: 1, leKos: { vorname: 1, nachname: 1, guestAccount: 1, handynummer: 1 } });
  if (!kpf) return [];

  const lekos: Mitarbeiter[] = [...(kpf.leKos as Mitarbeiter[])];
  for (const skpfID of kpf.substituteKPFIDs ?? []) {
    lekos.push(...(await Mitarbeiter.getPublicLeKoByKPF(skpfID)(gqlFields)));
  }

  return lekos;
};

const getSubstituteForLeKosKPF = registerQuery({
  type: () => [Mitarbeiter],
  operationName: 'getSubstituteLeKosKPF',
  params: [{ type: () => String, name: 'kpfID' }],
  resolve: resolveGetSubstituteLeKosKPF,
});

export namespace EmployeePublicInformationAPI {
  export const getSubstituteLeKosKPF = getSubstituteForLeKosKPF;
}
